import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';

// Layouts
import LayoutV1 from './routes/LayoutV1';
import LayoutV2 from './routes/LayoutV2';
import LayoutAdmin from './routes/LayoutAdmin';
import AdminProtectedRoute from './routes/AdminProtectedRoute';

// Páginas V1
import Home from './pages/Home';
import CategoriesPage from './pages/CategoriesPage';
import CategoryProductsPage from './pages/CategoryProductsPage';
import AllProductsPage from './pages/AllProductsPage';
import ProductPage from './pages/ProductPage';
import LoginPage from './pages/LoginPage';
import NotFound from './pages/NotFound';

// Admin
import SyncPage from './pages/SyncPage';
import AdminProductsPage from './pages/AdminProductsPage';
import AdminProductFormPage from './pages/AdminProductFormPage';
import AdminPricingRulesPage from './pages/AdminPricingRulesPage';
import AdminCategoryMappingsPage from './pages/AdminCategoryMappingsPage';
import AdminCategoriesPage from './pages/AdminCategoriesPage';

// Páginas V2
import HomeV2 from './pages/HomeV2';

const App = () => (
  <CartProvider>
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>

        {/* ── Login admin — sin layout ───────────────────── */}
        <Route path="/79834yhbdgyt562xa" element={<LoginPage />} />

        {/* ── V1 — home + catálogo principal ───────────── */}
        <Route element={<LayoutV1 />}>
          <Route path="/"                                                  element={<Home />} />
          <Route path="/categorias"                                        element={<CategoriesPage />} />
          <Route path="/categorias/:categoryName"                          element={<CategoryProductsPage />} />
          <Route path="/categorias/:categoryName/:subcategoryName"         element={<CategoryProductsPage />} />
          <Route path="/productos/todos"                                   element={<AllProductsPage />} />
          <Route path="/productos/:slug"                                   element={<ProductPage />} />
        </Route>

        {/* ── Admin — layout propio ──────────────────────── */}
        <Route element={<AdminProtectedRoute />}>
          <Route element={<LayoutAdmin />}>
            <Route path="/admin/sync"                              element={<SyncPage />} />
            <Route path="/admin/products"                          element={<AdminProductsPage />} />
            <Route path="/admin/products/new"                      element={<AdminProductFormPage />} />
            <Route path="/admin/products/edit/:id"                 element={<AdminProductFormPage />} />
            <Route path="/admin/pricing-rules"                     element={<AdminPricingRulesPage />} />
            <Route path="/admin/category-mappings"                 element={<AdminCategoryMappingsPage />} />
            <Route path="/admin/categories"                        element={<AdminCategoriesPage />} />
          </Route>
        </Route>

        {/* ── V2 — solo home de prueba ────────────────────── */}
        <Route element={<LayoutV2 />}>
          <Route path="/v2" element={<HomeV2 />} />
        </Route>

        <Route path="*" element={<NotFound />} />

      </Routes>
    </Router>
  </CartProvider>
);

export default App;
